import React, { useEffect, useState } from 'react';
import "./VipMyBenefits.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { ClaimVipBenefit, GETVipBenifits } from '../../../features/auth/Slice';
import Successfull_strip_modal from '../../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal';

const BENEFITS_DATA = [
  {
    id: 1,
    title: "Level up rewards",
    desc: "Each account can only receive 1 time",
    coin: "690",
    cash: "0",
    status: "received",
    img: "/assets/images/vip/vipMyBenefits/my_benefit_img.png"
  },
  {
    id: 2,
    title: "Level up rewards",
    desc: "Each account can only receive 1 time",
    coin: "690",
    cash: "0",
    status: "active",
    img: "/assets/images/vip/vipMyBenefits/my_benefit_img.png"
  },

  {
    id: 2,
    title: "Level up rewards",
    desc: "Each account can only receive 1 time",
    coin: "690",
    cash: "0",
    status: "active",
    img: "/assets/images/vip/vipMyBenefits/my_benefit_img.png"
  },

  {
    id: 2,
    title: "Level up rewards",
    desc: "Each account can only receive 1 time",
    coin: "690",
    cash: "0",
    status: "active",
    img: "/assets/images/vip/vipMyBenefits/my_benefit_img.png"
  },

  {
    id: 2,
    title: "Level up rewards",
    desc: "Each account can only receive 1 time",
    coin: "690",
    cash: "0",
    status: "active",
    img: "/assets/images/vip/vipMyBenefits/my_benefit_img.png"
  },

  {
    id: 2,
    title: "Level up rewards",
    desc: "Each account can only receive 1 time",
    coin: "690",
    cash: "0",
    status: "active",
    img: "/assets/images/vip/vipMyBenefits/my_benefit_img.png"
  },
  // ... other items
];

function VipMyBenefits() {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");


  const dispatch = useDispatch()

  const VipBenifits = useSelector((state) => state.auth.VipBenefits);

  useEffect(() => { dispatch(GETVipBenifits()) }, [dispatch]);


  const ClaimBenefitOfVip = async (id) => {

    const res = await dispatch(ClaimVipBenefit({ benefit_id: id }));
    if (res.meta?.requestStatus === "fulfilled") {
      setModalMessage("Reward Claimed Successfully!");
      setModalShow(true);
      setTimeout(() => {
        setModalShow(false);
        navigate(0);
      }, 2000);
    } else {
      setModalMessage(res?.payload?.errors || "Submission failed. Please try again");
      setModalShow(true);
      setTimeout(() => setModalShow(false), 3000);
    }


  }

  return (
    <div className="VipMyBenefits">
      <div className="benefits_header">
        <span className="diamond_icon">💎</span>
        <h3>My Benefits</h3>
      </div>

      <div className="benefits_grid">
        {VipBenifits?.map((item) => (
          <div key={item.id} className="benefit_card">
            <div className="card_image_box">
              <img src={"/assets/images/vip/vipMyBenefits/my_benefit_img.png"} alt={item.name} />
              <div className="image_overlay_tags">
                <span className="tag_left">🪙 {item.coin}</span>
                <span className="tag_right">💰 {item.cash}</span>
              </div>
            </div>

            <div className="card_content">
              <h4>{item.name || ""}</h4>
              <p>{item.remark || ""}</p>


              {item?.id === 3 ? null : item?.id === 4 ? (
                <button
                  className="btn_details"
                  onClick={() => navigate("/vip-details-history")}
                >
                  Check the details
                </button>
              ) : item.claimed ? (
                <button className="btn_received" disabled>
                  Received
                </button>
              ) : (
                <button className="btn_claim" onClick={() => ClaimBenefitOfVip(item?.id)}>
                  Claim
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </div>
  );
}

export default VipMyBenefits;